"use client";

import { useLanguage } from "@/components/LanguageProvider";

export function MaintenancePreviewBanner() {
  const { t } = useLanguage();
  return (
    <div
      role="status"
      className="sticky top-0 z-[60] border-b border-amber-400 bg-amber-100 px-4 py-2.5 text-center text-sm font-semibold text-amber-950"
    >
      {t("maintenance.preview.banner")}
    </div>
  );
}
